import { trpc } from "../trpc";

interface Input {
  folderId?: string;
}

export function useDeleteChatbot(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  return trpc.chatbot.delete.useMutation({
    onSettled: () => {
      utils.chatbot.list.invalidate();

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({
          folderId,
        });
      }
    },
  });
}
